import { createSelector } from 'reselect';
import { getTabName } from '~/utils/filterGroups';
import { ApplicationState } from '../store';
import { getNotEmptyOrdersFilters, getOrderFiltersValues, getQSSaved } from './router.selectors';

export const getFiltersStore = (state: ApplicationState) => state.filters;

export const getFilterGroupNameFromProps = (_: unknown, props: { filterGroupName: string }) =>
  props.filterGroupName;

export const getFilterValues = createSelector(
  getFiltersStore,
  getFilterGroupNameFromProps,
  (filtersStore, filterGroupName) => filtersStore.data[filterGroupName],
);

export const getSaveOrderViewModalIsOpen = createSelector(
  getFiltersStore,
  (filtersStore) => filtersStore.saveOrderViewModalIsOpen,
);

export const getDeleteOrderViewModalIsOpen = createSelector(
  getFiltersStore,
  (filtersStore) => filtersStore.deleteOrderViewModalIsOpen,
);

export const getShowNewTab = createSelector(
  getFiltersStore,
  (filtersStore) => filtersStore.showNewTab,
);

export const getCurrentFilterGroups = createSelector(
  getFiltersStore,
  (filtersStore) => filtersStore.filterGroups,
);

export const getFilterGroupsIsLoading = createSelector(
  getFiltersStore,
  (filterStore): boolean => filterStore.filterGroupsIsLoading,
);

export const getSearchQueryValue = createSelector(
  getFiltersStore,
  (filtersStore): string => filtersStore.queryString,
);

export const getSelectedTab = createSelector(
  getQSSaved,
  getNotEmptyOrdersFilters,
  getOrderFiltersValues,
  getCurrentFilterGroups,
  (savedTabName, notEmptyOrdersFilters, orderFiltersValues, currentFilterGroups) => {
    return getTabName(notEmptyOrdersFilters, orderFiltersValues, savedTabName, currentFilterGroups);
  },
);

export const isNewTabSelected = createSelector(
  getSelectedTab,
  (selectedTab): boolean => selectedTab === 'new',
);

export const getTempFilters = createSelector(
  getFiltersStore,
  (filtersStore) => filtersStore.tempFilterGroup,
);
